///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalPoll {
    import Controller = TotalCore.Common.Controller;
    import IRootScopeService = angular.IRootScopeService;
    import IScope = angular.IScope;

    @Controller('controllers.totalpoll')
    export class ModulesCtrl {
        public installerVisibility = false;

        public constructor(private $rootScope: IRootScopeService, private $scope: IScope) {

        }

        public $onInit() {
            this.$rootScope.$applyAsync(() => {
                if (!this.$rootScope.getCurrentTab()) {
                    this.$rootScope.setCurrentTab('modules>installed');
                }
            });
        }

        public isInstallerVisible() {
            return this.installerVisibility;
        }

        public refresh() {
            this.$scope.$applyAsync(() => {
                this.$rootScope.$manager.refresh(true);
            });
        }

        public toggleInstaller() {
            this.installerVisibility = !this.installerVisibility;
        }
    }

}